import React, { Component, useEffect } from "react";
import { Menu } from "antd";
import { Link } from "react-router-dom";

import CustomScrollbars from "util/CustomScrollbars";
import SidebarLogo from "./SidebarLogo";

import Auxiliary from "util/Auxiliary";
import UserProfile from "./UserProfile";
import AppsNavigation from "./AppsNavigation";
import
{
    NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
    NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
    THEME_TYPE_LITE
} from "../../constants/ThemeSetting";
import IntlMessages from "../../util/IntlMessages";
import { connect } from "react-redux";

const SubMenu = Menu.SubMenu;
const MenuItemGroup = Menu.ItemGroup;

class SidebarContent extends Component
{
    getNoHeaderClass = navStyle =>
    {
        if (
            navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR ||
            navStyle === NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR
        )
        {
            return "gx-no-header-notifications";
        }
        return "";
    };
    getNavStyleSubMenuClass = navStyle =>
    {
        if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR)
        {
            return "gx-no-header-submenu-popup";
        }
        return "";
    };

    render()
    {


        const { themeType, navStyle, pathname } = this.props;
        const selectedKeys = pathname.substr(1);
        const defaultOpenKeys = selectedKeys.split("/")[1];
        return (
            <Auxiliary>
                <SidebarLogo />
                <div className="gx-sidebar-content">
                    <div
                        className={`gx-sidebar-notifications ${this.getNoHeaderClass(
                            navStyle
                        )}`}
                    >
                        <UserProfile />
                        <AppsNavigation />
                    </div>
                    <CustomScrollbars className="gx-layout-sider-scrollbar">
                        <Menu
                            defaultOpenKeys={[defaultOpenKeys]}
                            selectedKeys={[selectedKeys]}
                            theme={
                                themeType === THEME_TYPE_LITE ? "lite" : "dark"
                            }
                            mode="inline"
                        >
                            {/**ADMIN PANEL */}
                            {(localStorage.getItem("roles") &&
                                (localStorage.getItem("roles").includes('Admin') || localStorage.getItem("roles").includes('OrderSupportLeveTwo')
                                    || localStorage.getItem("roles").includes('OrderSupportLeveOne') || localStorage.getItem("roles").includes('ConfirmationSupport')
                                    || localStorage.getItem("roles").includes('AnswerSupport')
                                )) && (
                                    <MenuItemGroup
                                        key="main"
                                        className="gx-menu-group"
                                        title={
                                            <IntlMessages id="sidebar.adminPanel" />
                                        }
                                    >
                                        {
                                            localStorage.getItem("roles").includes('Admin') ||
                                                localStorage.getItem("roles").includes('OrderSupportLeveTwo') ?
                                                <Menu.Item key="adminpanel/cc">
                                                    <Link to="/adminpanel/cc">
                                                        <i className="icon icon-crypto" />
                                                        <IntlMessages id="sidebar.adminpanel.changecc" />
                                                    </Link>
                                                </Menu.Item>

                                                : <React.Fragment></React.Fragment>

                                        }
                                        {
                                            localStorage.getItem("roles").includes('Admin') ||
                                                localStorage.getItem("roles").includes('OrderSupportLeveTwo') ?
                                                <Menu.Item key="adminpanel/payment">
                                                    <Link to="/adminpanel/payment">
                                                        <i className="icon icon-card" />
                                                        <IntlMessages id="sidebar.adminpanel.payment" />
                                                    </Link>
                                                </Menu.Item>
                                                : <React.Fragment></React.Fragment>

                                        }
                                        {
                                            localStorage.getItem("roles").includes('Admin') ||
                                                localStorage.getItem("roles").includes('OrderSupportLeveTwo') ?
                                                <Menu.Item key="adminpanel/carts">
                                                    <Link to="/adminpanel/carts">
                                                        <i className="icon icon-card" />
                                                        <IntlMessages id="sidebar.adminpanel.carts" />
                                                    </Link>
                                                </Menu.Item>
                                                : <React.Fragment></React.Fragment>

                                        }

                                        {
                                            localStorage.getItem("roles").includes('Admin') ||
                                                localStorage.getItem("roles").includes('ConfirmationSupport') ||
                                                localStorage.getItem("roles").includes('OrderSupportLevelOne') ||
                                                localStorage.getItem("roles").includes('OrderSupportLeveTwo') ||
                                                localStorage.getItem("roles").includes('AnswerSupport') ?
                                                <Menu.Item key="adminpanel/usermanagement">
                                                    <Link to="/adminpanel/usermanagement">
                                                        <i className="icon icon-all-contacts" />
                                                        <IntlMessages id="sidebar.adminpanel.usermanagement" />
                                                    </Link>
                                                </Menu.Item>
                                                :
                                                <React.Fragment></React.Fragment>

                                        }
                                        {
                                            localStorage.getItem("roles").includes('Admin') ||
                                                localStorage.getItem("roles").includes('ConfirmationSupport') ?
                                                <Menu.Item key="adminpanel/confirmverification">
                                                    <Link to="/adminpanel/confirmverification">
                                                        <i className="icon icon-check" />
                                                        <IntlMessages id="sidebar.adminpanel.confirmverification" />
                                                    </Link>
                                                </Menu.Item>
                                                :
                                                <React.Fragment></React.Fragment>
                                        }
                                        {
                                            localStorage.getItem("roles").includes('Admin') ||
                                                localStorage.getItem("roles").includes('ConfirmationSupport') ||
                                                localStorage.getItem("roles").includes('AnswerSupport') ?
                                                <Menu.Item key="adminpanel/ticket">
                                                    <Link to="/adminpanel/ticket">
                                                        <i className="icon icon-files" />
                                                        <IntlMessages id="sidebar.adminpanel.ticket" />
                                                    </Link>
                                                </Menu.Item>
                                                :
                                                <React.Fragment></React.Fragment>
                                        }

                                        {
                                            localStorage.getItem("roles").includes('Admin') ||
                                                localStorage.getItem("roles").includes('OrderSupportLevelOne') ||
                                                localStorage.getItem("roles").includes('OrderSupportLeveTwo') ?
                                                <Menu.Item key="adminpanel/orderhistory">
                                                    <Link to="/adminpanel/orderhistory">
                                                        <i className="icon icon-timepicker" />
                                                        <IntlMessages id="sidebar.adminpanel.orderhistory" />
                                                    </Link>
                                                </Menu.Item>
                                                : <React.Fragment></React.Fragment>

                                        }

                                        {
                                            localStorage.getItem("roles").includes('Admin') ||
                                                localStorage.getItem("roles").includes('OrderSupportLevelOne') ||
                                                localStorage.getItem("roles").includes('OrderSupportLevelTwo') ?
                                                <Menu.Item key="adminpanel/balance">
                                                    <Link to="/adminpanel/balance">
                                                        <i className="icon icon-bitcoin" />
                                                        <IntlMessages id="sidebar.adminpanel.balance" />
                                                    </Link>
                                                </Menu.Item>
                                                : <React.Fragment></React.Fragment>

                                        }
                                        {
                                            localStorage.getItem("roles").includes('Admin') ||
                                                localStorage.getItem("roles").includes('SuperAdmin') ?
                                                <Menu.Item key="adminpanel/content">
                                                    <Link to="/adminpanel/content">
                                                        <i className="icon icon-files" />
                                                        <IntlMessages id="sidebar.adminpanel.content" />
                                                    </Link>
                                                </Menu.Item>
                                                : <React.Fragment></React.Fragment>

                                        }
                                        {
                                            localStorage.getItem("roles").includes('Admin') ||
                                                localStorage.getItem("roles").includes('ConfirmationSupport') ||
                                                localStorage.getItem("roles").includes('OrderSupportLevelOne') ||
                                                localStorage.getItem("roles").includes('OrderSupportLeveTwo') ||
                                                localStorage.getItem("roles").includes('AnswerSupport') ?
                                                <Menu.Item key="adminpanel/blacklistmanagement">
                                                    <Link to="/adminpanel/blacklistmanagement">
                                                        <i className="icon icon-all-contacts" />
                                                        <IntlMessages id="sidebar.adminpanel.blacklistmanagement" />
                                                    </Link>
                                                </Menu.Item>
                                                :
                                                <React.Fragment></React.Fragment>

                                        }

                                    </MenuItemGroup>
                                )}
                            {/**USERPANEL */}
                            <MenuItemGroup
                                key="main"
                                className="gx-menu-group"
                                title={<IntlMessages id="sidebar.userpanel" />}
                            >
                                <Menu.Item key="userpanel/profile">
                                    <Link to="/userpanel/profile">
                                        <i className="icon icon-profile" />
                                        <IntlMessages id="sidebar.profile" />
                                    </Link>
                                </Menu.Item>

                                <Menu.Item key="userpanel/order">
                                    <Link to="/userpanel/order">
                                        <i className="icon icon-shopping-cart" />
                                        <IntlMessages id="sidebar.order" />
                                    </Link>
                                </Menu.Item>
                                <Menu.Item key="userpanel/referral">
                                    <Link to="/userpanel/referral">
                                        <i className="icon icon-revenue-new" />
                                        <IntlMessages id="sidebar.referral" />
                                    </Link>
                                </Menu.Item>
                                <Menu.Item key="userpanel/addCard">
                                    <Link to="/userpanel/addCard">
                                        <i className="icon icon-add" />
                                        <IntlMessages id="sidebar.addcard" />
                                    </Link>
                                </Menu.Item>
                                <Menu.Item key="userpanel/verification">
                                    <Link to="/userpanel/verification">
                                        <i className="icon icon-auth-screen" />
                                        <IntlMessages id="sidebar.verification" />
                                    </Link>
                                </Menu.Item>
                                <Menu.Item key="userpanel/ticket">
                                    <Link to="/userpanel/ticket">
                                        <i className="icon icon-files" />
                                        <IntlMessages id="sidebar.ticket" />
                                    </Link>
                                </Menu.Item>
                                <Menu.Item key="userpanel/orderhistory">
                                    <Link to="/userpanel/orderhistory">
                                        <i className="icon icon-timepicker" />
                                        <IntlMessages id="sidebar.orderhistory" />
                                    </Link>
                                </Menu.Item>
                                <Menu.Item key="/authorization/">
                                    <Link to="/authorization/">
                                        <i className="icon icon-signin" />
                                        <IntlMessages id="sidebar.logout" />
                                    </Link>
                                </Menu.Item>
                            </MenuItemGroup>
                        </Menu>
                    </CustomScrollbars>
                </div>
            </Auxiliary>
        );
    }
}

SidebarContent.propTypes = {};
const mapStateToProps = ({ settings }) =>
{
    const { navStyle, themeType, locale, pathname } = settings;
    return { navStyle, themeType, locale, pathname };
};
export default connect(mapStateToProps)(SidebarContent);
